module.exports = __webpack_public_path__ + "static/img/egg_g_21.0ae4cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_21.png
// module id = EGmE
// module chunks = 1